<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->
<crucible-dialog
  dialogTitle="Add VM Credentials"
  submitLabel="Add"
  cancelLabel="Cancel"
  [guardUnsavedWork]="true"
  (cancel)="onClick(false)"
  (submit)="onClick(true)"
>
  <div crucibleDialogContent class="content">
    <mat-form-field class="param-full-width">
      <mat-label>Username</mat-label>
      <input
        matInput
        placeholder="Username"
        [(ngModel)]="data.vmCredential.username"
        tabindex="1"
        cdkFocusInitial
      />
    </mat-form-field>
    <mat-form-field class="param-full-width">
      <mat-label>Password</mat-label>
      <input
        matInput
        [type]="'password'"
        placeholder="Password"
        [(ngModel)]="data.vmCredential.password"
        tabindex="2"
      />
    </mat-form-field>
    <mat-form-field class="param-full-width">
      <mat-label>Description</mat-label>
      <input
        matInput
        placeholder="Description"
        [(ngModel)]="data.vmCredential.description"
        tabindex="3"
      />
    </mat-form-field>
  </div>
</crucible-dialog>
